module.exports = __webpack_public_path__ + "static/media/bg1.bdbc97af.jpg";